import { createStyles, makeStyles } from '@material-ui/core/styles'

import { lengthOfDayInPx, weekLength } from '../../utils/constants'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      position: 'absolute',
      height: '100%',
      backgroundColor: 'red',
      left: '20.6rem',

      pointerEvents: 'none',
    },

    today: {
      position: 'absolute',
      top: -8,
      bottom: -8,

      height: 'calc(100% + 16px)',
      marginLeft: '-1.6rem',

      zIndex: 2,

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& > span': {
        width: 56,
        minHeight: 24,
        padding: '0.4rem 1.6rem',

        fontWeight: 600,
        fontSize: '1.1rem',
        lineHeight: '1.2rem',

        border: `1px solid ${palette.secondary.main}`,
        borderRadius: 40,
        backgroundColor: palette.background.paper,
      },

      '& > hr': {
        backgroundColor: palette.secondary.main,
        width: 2,
      },
    },

    week: {
      position: 'absolute',

      width: lengthOfDayInPx * weekLength,
      height: 'calc(100%)',
      top: '3rem',

      backgroundColor: '#F8F8F8',
      borderRadius: 4,
    },
  }),
)
